import { useState } from 'react';

import { CallDetails } from '@/widgets/callDetails';
import { LeadCallsTable } from './LeadCallsTable';

export function LeadCalls({ phone }: { phone: string }) {
  const [selectedCallId, setSelectedCallId] = useState<string | null>(null);

  return (
    <div className="mt-4 overflow-hidden flex gap-4 min-w-0">
      <div className="flex-1 min-w-0">
        <LeadCallsTable phone={phone} onSelect={setSelectedCallId} />
      </div>

      <div className="flex-1 min-w-[400px] max-w-[600px]">
        <CallDetails callId={selectedCallId} isLinkLead={false} />
      </div>
    </div>
  )
}